import type { PadType } from '@tencent/docs-mime-types';
import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';

export async function getDownloadExtension(): Promise<{
    export: (options: {
        padType: PadType;
        params: {
            docId: string;
        };
        allowDownloadInElectronApp?: boolean;
        hasAttachments?: boolean;
        fontOptions?: {
            hasWebFonts?: boolean;
            hasTencentSans?: boolean;
            hasVipFonts?: boolean;
        };
        meta: {
            title: string;
            url: string;
        };
        appShowType?: number;
    }) => void;
}> {
    const downloadExtension: any = await ArkLoader.extensionService.getExtension(componentConfig.name);
    return downloadExtension;
}
